export default "__VITE_ASSET__DRbA4R5V__"